var logoGoogle = "https://shopfront-cdn.tekoapis.com/static/d7b3d575b3e8fc03.svg";

export { logoGoogle as default };
